import type { IconSvgObject } from './types';

const FishingHookIcon: IconSvgObject = [
  ["circle", { cx: "7", cy: "8", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 6V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 10V16C7 19.3137 9.68629 22 13 22C16.3137 22 19 19.3137 19 16V11L17 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FishingHookIcon;
